<template>
  <!-- <div class="success_message d-flex-row align-start justify-start">
    <img
      src="/images/games/marvel-rivals-boost/game_icon.webp"
      alt="warning_icon"
      height="30"
      width="30"
      class="b-radius-35"
    />
    <p class="t-white font-family-2 medium-m">
      {{ $t("new_warnings.marvel-rank-boost") }}
    </p>
  </div> -->
  <div class="d-flex-row space-between lg-row-to-col">
    <rank-division-picker
      :type="'currentRank'"
      item-key="rankBoosting"
      :title="$t('calculators_common.current_rank')"
      class="flex-5 flex-lg-10"
    />
    <DoubleRight />
    <rank-division-picker
      :type="'desiredRank'"
      item-key="rankBoosting"
      :prev-rank="checkoutStore.getDetails.currentRank"
      :title="$t('calculators_common.desired_rank')"
      class="flex-5 flex-lg-10"
    />
  </div>
  <ExtraOptionPicker />
  <PlatformPicker />
  <OptionPicker />

  <RolesPicker :select-only-one-role="true" :max1="true" />
  <ChampionsPicker />
</template>

<script setup>
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import DoubleRight from "~/components/icons/DoubleRight.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import RolesPicker from "../lol/pickers/RolesPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
// import RankDivisionPick from "./pickers/RankDivisionPick.vue";
import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  // const currentRank = gameStore.getGameRanks || []
  checkoutStore.setOneRole({
    roleId: gameStore.getGame.roles[0]?.id,
  });
  if (gameStore.getGameRanks?.length > 0) {
    const currentRank = gameStore.getGameRanks[0];
    const desiredRank = gameStore.getGameRanks[1];
    checkoutStore.setDetails({
      currentDivision: currentRank.divisions[0]?.id,
      currentDivisionTitle: currentRank.divisions[0]?.title,
      currentRank: currentRank.id,
      currentRankTitle: currentRank.title,
      desiredDivision: desiredRank.divisions[0]?.id,
      desiredDivisionTitle: desiredRank.divisions[0]?.title,
      desiredRank: desiredRank.id,
      desiredRankTitle: desiredRank.title,
    });
  }

  checkoutStore.setServer(gameStore.getGame.servers[0]?.id);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();
onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
